import { getLink } from '../../../../utils/utils';

const content = {
	rus: (
		`
		<div class="poem mb-5">
			<p class="poem-block mb-3">
				No sun - no moon!<br/>
				No morn - no noon!<br/>
				No dawn - no dusk - no proper time of day -<br/>
				No sky - no earthly view -<br/>
				No distance looking blue -
			</p>

			<p class="poem-block mb-3">
				No road - no street -<br/>
				No "t'other side the way" -<br/>
				No end to any Row -<br/>
				No indications where the Crescents go
			</p>

			<p class="poem-block mb-3">
				No top to any steeple -<br/>
				No recognitions of familiar people -<br/>
				No courtesies for showing 'em -<br/>
				No knowing 'em!
			</p>

			<p class="poem-block mb-3">
				No mail - no post -<br/>
				No news from any foreign coast -<br/>
				No park - no ring - no afternoon gentility -<br/>
				No company - no nobility
			</p>

			<p class="poem-block mb-3">
				No warmth, no cheerfulness, no healthful ease,<br/>
				No comfortable feel in any member - <br/>
				No shade, no shine, no butterflies, no bees,<br/>
				No fruits, no flowers, no leaves, no birds,<br/>
				November!
			</p>
		</div>

		<div class="poem">
			<p class="poem-block mb-3 text-center bold">
				Ноябрь
			</p>

			<p class="poem-block mb-3">
				Но где же солнце, где луна,<br/>
				Ни дня, ни ночи нет, ни сна,<br/>
				Ни вечера, ни утра нет,<br/>
				Не сумерки и не рассвет…
			</p>

			<p class="poem-block mb-3">
				Над улицей сереет мгла,<br/>
				Нет неба, солнца и тепла…<br/>
				Ни в ком не встретишь тёплых чувств,<br/>
				Нетоплен дом твой, мёртв и пуст.
			</p>

			<p class="poem-block mb-3">
				На плечи давит тяжесть лет, -<br/>
				Не купишь в прошлое билет!<br/>
				Ни тени нет, ни света нет…
			</p>

			<p class="poem-block mb-3">
				Невыносимо в этом мире;<br/>
				Напрасно просим мы о мире:<br/>
				Нет мира ни в душе, ни вне.<br/>
				Никто не отвечает мне<br/>
				На зов души моей печальный.
			</p>

			<p class="poem-block mb-3">
				На юг, в свой путь тяжёлый, дальний<br/>
				Надолго улетели птицы -<br/>
				Нам они могут только сниться…
			</p>

			<p class="poem-block mb-3">
				Нет бабочек и нет цветов,<br/>
				Нет листьев, зелени, плодов…<br/>
				Но что же значит эта хмарь?<br/>
				Но-ябрь.
			</p>
		</div>
		`
	)
}

const itemName = {
	rus: 'November'
}

const item = {
	itemlink: getLink(itemName.rus),
	rus:{
		itemName: itemName.rus,
		itemContent: content.rus,
		itemAuthor: "by Thomas Hood <br/> Перевод Татьяны Аудерской",
	}
}

export default item;